import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Ledgerentries } from "./../../master/ledger/shared/ledgerentries.model";
import { Voucher } from "../voucher/shared/voucher.model";

@Injectable({
  providedIn: 'root'
})

export class OpbalanceserviceService {

  ledgerentries: Ledgerentries;
  // selectedVoucher: Voucher;

  constructor(private httpClient: HttpClient) {
    this.ledgerentries = new Ledgerentries; // initial binding data
    // this.selectedVoucher = new Voucher; // for saving data

  }

  getBaseUrl() {
    
    return environment.baseUrl;
  }

  IUDOpbalance(ledgerentries: Ledgerentries) {
    // ledgerentries.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    // ledgerentries.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // ledgerentries.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    // ledgerentries.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    ledgerentries.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    ledgerentries.PersonId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    ledgerentries.Isopening = true; 
    let body = ledgerentries;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Accounts/IUD', body, { headers: headers });
  }

  FetchLedgerEntriesList() {
    
    this.ledgerentries = new Ledgerentries();
    this.ledgerentries.Isopening = true;     // for opening balance sp selection
    this.ledgerentries.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.ledgerentries.FromDate = new Date(localStorage.getItem("FromDate"));
    this.ledgerentries.ToDate = new Date(localStorage.getItem("ToDate"));  // to search date 

    // this.selectedVoucher.Ledgerentries = new Ledgerentries();
    // this.selectedVoucher.Ledgerentries.Isopening = true;     // for opening balance sp selection
    // this.selectedVoucher.Ledgerentries.CostCentreId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // this.selectedVoucher.Ledgerentries.FromDate = new Date(localStorage.getItem("FromDate"));
    // this.selectedVoucher.Ledgerentries.ToDate = new Date(localStorage.getItem("ToDate"));  // to search date 
    // let body = this.selectedVoucher.Ledgerentries;

    let body = this.ledgerentries;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Accounts/FetchList', body, { headers: headers });
  }

  FetchAutogeneratedNumber() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AutoGeneratedNumber', body, { headers: headers });
  }

  // IUDVoucher(voucher: Voucher) {

  //   voucher.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   voucher.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   voucher.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
  //   voucher.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   voucher.CreatedDate  = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
  //   voucher.ModifiedDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

  //   let body = voucher;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/voucher/IUD', body, { headers: headers });
  // }

}
